import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_VDialogAdapted = _resolveComponent("VDialogAdapted")!

  return (_openBlock(), _createBlock(_component_VDialogAdapted, _mergeProps({
    modelValue: _ctx.lazyValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lazyValue) = $event)),
    class: ["base-dialog", _ctx.classes],
    "content-class": "base-dialog-content overflow-visible"
  }, _ctx.$attrs), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          (slot === 'default')
            ? (_openBlock(), _createElementBlock("div", {
                key: `wrapper_${slot}`,
                class: "base-dialog-wrapper",
                onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onWrapperClicked && _ctx.onWrapperClicked(...args)))
              }, [
                _createElementVNode("div", {
                  class: "base-dialog-wrapper-content",
                  style: _normalizeStyle(_ctx.contentWidth ? `width: ${_ctx.contentWidth}` : '')
                }, [
                  (slot === 'default' && _ctx.close)
                    ? (_openBlock(), _createBlock(_component_BaseIcon, {
                        key: `slot-${slot}`,
                        variant: "close",
                        class: _normalizeClass(`m_position-absolute m_top-10 m_right-10 mti_m_top-0 mti_m_right-0 m_cursor-pointer m_zindex-10 ${_ctx.closeClass}`),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.lazyValue = null))
                      }, null, 8, ["class"]))
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope)))
                ], 4)
              ], 32))
            : _renderSlot(_ctx.$slots, slot, _normalizeProps(_mergeProps({ key: 1 }, scope)))
        ])
      }
    })
  ]), 1040, ["modelValue", "class"]))
}